import { getIn } from "formik";

const Input = ({ field, form, ...props }) => {
  const newProps = {
    ...props,
    className: `${props.className} ${
      getIn(form.errors, field.name) ? "is-invalid" : ""
    }`,
  };
  return <input {...field} value={field.value ?? ""} {...newProps} />;
};

export default Input;
